module.exports = __webpack_public_path__ + "static/media/7.388afeb7.jpg";